/**
 * GlobalSnackbar - Observes UiStore snackbar state and renders notifications
 *
 * This component connects the UiStore.snackbar observable to the Snackbar UI component.
 * Place this in App.tsx to enable global snackbar notifications.
 */
import { observer } from "mobx-react-lite";
import { useStore } from "@/stores";
import { Snackbar } from "./Snackbar";

export const GlobalSnackbar = observer(function GlobalSnackbar() {
  const { uiStore } = useStore();
  const { snackbar, hideSnackbar } = uiStore;

  if (!snackbar.visible) {
    return null;
  }

  return (
    <Snackbar
      message={snackbar.message}
      type={snackbar.type}
      onClose={hideSnackbar}
    />
  );
});
